import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import Home from "./pages/Home";
import LogoShowcase from "./pages/LogoShowcase";
import Blog from "./pages/Blog";
import BlogArticle from "./pages/BlogArticle";
import MaintenancePage from "./pages/MaintenancePage";

// 🔧 MODE MAINTENANCE : Changez à true pour activer la maintenance
const MAINTENANCE_MODE = false;

function App() {
  // Si le mode maintenance est activé, afficher uniquement la page de maintenance
  if (MAINTENANCE_MODE) {
    return <MaintenancePage />;
  }

  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/logos" element={<LogoShowcase />} />
            <Route path="/blog" element={<Blog />} />
            <Route path="/blog/:slug" element={<BlogArticle />} />
          </Routes>
        </BrowserRouter>
        <Toaster />
      </div>
    </LanguageProvider>
  );
}

export default App;
